import { render, staticRenderFns } from "./KokubanOutput.vue?vue&type=template&id=6e0267b6&scoped=true&"
import script from "./KokubanOutput.vue?vue&type=script&lang=js&"
export * from "./KokubanOutput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0267b6",
  null
  
)

export default component.exports